import React, { useEffect, useRef } from 'react';
import QRCodeStyling from 'qr-code-styling';

const QRCodeWithLogo = ({ 
  value, 
  size = 256, 
  showLogo = false,
  logoUrl = null, // Custom logo URL for premium users
  qrColor = '#d97706', // Amber-600 by default
  bgColor = '#ffffff'
}) => {
  const ref = useRef(null);
  const qrCode = useRef(null);

  // Determine which logo to use
  const logoImage = showLogo ? (logoUrl || '/piper-logo-qr.png') : null;

  useEffect(() => {
    const qrOptions = {
      width: size,
      height: size,
      data: value,
      margin: 0,
      qrOptions: {
        typeNumber: 0,
        mode: 'Byte',
        errorCorrectionLevel: 'H' // High error correction for logo
      },
      dotsOptions: {
        color: qrColor,
        type: 'rounded'
      },
      backgroundOptions: {
        color: bgColor
      },
      cornersSquareOptions: {
        color: qrColor,
        type: 'extra-rounded'
      },
      cornersDotOptions: {
        color: qrColor,
        type: 'dot'
      }
    };

    // Add logo if showLogo is true
    if (showLogo && logoImage) {
      qrOptions.image = logoImage;
      qrOptions.imageOptions = {
        hideBackgroundDots: true,
        imageSize: 0.3,
        margin: 4,
        crossOrigin: 'anonymous'
      };
    }

    if (!qrCode.current) {
      qrCode.current = new QRCodeStyling(qrOptions);
    } else {
      qrCode.current.update(qrOptions);
    }

    if (ref.current) {
      ref.current.innerHTML = '';
      qrCode.current.append(ref.current);
    }
  }, [value, size, showLogo, logoImage, qrColor, bgColor]);

  return <div ref={ref} />;
};

export default QRCodeWithLogo;
